import { Record } from 'immutable';
class DateRange extends Record({
  endDate: 0,
  startDate: 0
}, 'DateRange') {
  isEmpty() {
    return !this.endDate && !this.startDate;
  }
}
export default DateRange;